import { makeImmerReducer } from './utils';

/**
 * Keep track of which event is currently being scrolled in the event list
 * So other overflowed events disable scrolling
 */

export interface CurrentScrollEventState {
  currentScrollEventId: string | undefined;
}

export const initialState: CurrentScrollEventState = {
  currentScrollEventId: undefined,
};

export const currentScrollEventReducer = makeImmerReducer(initialState, (draft, action) => {
  switch (action.type) {
    case 'SET_CURRENT_SCROLL_EVENT':
      draft.currentScrollEventId = action.eventId;
      break;

    case 'CLEAR_CURRENT_SCROLL_EVENT':
      draft.currentScrollEventId = undefined;
      break;
  }
});
